//////////////////////////////////////////////
//! YTPLAYER
//////////////////////////////////////////////
var ytPlayer = {
	
	//track currently watching
	isOpen: false,
	watching: app.settings.trailerID,
	trailerWatched: false,//SHOULD BE FALSE BY DEFAULT
	
	//YTVID plugin settings
	settings:{
		containerID : "js-overlayContent",//MANDATORY
			id : app.settings.trailerID,//MANDATORY
			closeBtn : "trailerClose",//MANDATORY
			list : false, //OPTIONAL
			index : 0 , //OPTIONAL
			showinfo : 0, // OPTIONAL
			autoplay : 0, // OPTIONAL
			controls : 1,
			customControls : false,
			customBackground : false
	},

	
//////////////////////////////////////////////
//! initYT (create player)
//////////////////////////////////////////////

	initYT : function(){ 
		
		

		if (Detectizr.device.type == "desktop" && page.current == 'home' && page.viewed.home === false && app.settings.showTrailer) {
			
			
			
			ytPlayer.settings.autoplay = 1;
		}

		ytPlayer.settings.dispatcher = app.dispatcher;
		app.dispatcher.addEventlistener("YT_STATE_CHANGE", ytPlayer.states);
		ytPlayer.video = new YTVID(ytPlayer.settings);
		ytPlayer.video.add();
		ytPlayer.video.stop();
	},

//////////////////////////////////////////////
//! ytPlayer.states
//////////////////////////////////////////////

	states: function(event,data) {
		
		if(data === 0){
			ytPlayer.overlayClose();
		}
	},

//////////////////////////////////////////////
//! ytPlayer.swap()
//////////////////////////////////////////////

	//Swap current video
	swap : function(id){ debug('ytPlayer.swap to '+id);
		
		 if(Detectizr.device.type ==="desktop") {
			ytPlayer.video.player.loadVideoById(id);
		} else {
			ytPlayer.video.player.cueVideoById(id);
		}
		ytPlayer.watching = id;
	},

//////////////////////////////////////////////
//! ytPlayer.show()
//////////////////////////////////////////////

	//Open a video in the overlay
	show : function(ytid) {
		
		//Check for trailer overide
		if (ytid === 'trailer') {
			ytPlayer.swap(app.settings.trailerID);
			ytPlayer.video.stop();
		
		//else play specifiedvid
		} else {
			ytPlayer.swap(ytid);
			ytPlayer.video.stop();
		}
		
		//Open the overlay
		ytPlayer.overlayOpen();
	},

//////////////////////////////////////////////
//! ytPlayer.hide()
//////////////////////////////////////////////
	
	//Close the video overlay
	hide : function(callback){
		ytPlayer.overlayClose(callback);
	},

//////////////////////////////////////////////
//! ytPlayer.overlayOpen()
//////////////////////////////////////////////

	//Overlay animation
	overlayOpen : function(callback) {
		
		ytPlayer.isOpen = true;
		
		//Do before
		if(app.settings.creditsOpen) {app.creditManualSlide();}
		app.lockPageScroll(true);
		
		//pause audio
		
			audio.pause();
		
		//Animate ther overlay & iframe
		$('#js-overlay').fadeIn(app.settings.overlaySpeed);
		setTimeout(function(){
			$('#js-overlay iframe').animate({
				opacity: 1
			}, app.settings.overlaySpeed, function(){
				
// 				alert('1');
				//Check for desktop
				if (Detectizr.device.type == "desktop"){
// 					alert('2');
// 						ytPlayer.video.seek(0);
 						ytPlayer.video.play();
 						
					}

			});
		}, app.settings.overlaySpeed/2);
	},

//////////////////////////////////////////////
//! ytPlayer.overlayClose();
//////////////////////////////////////////////
	
	//Overlay Close anmation
	overlayClose : function() {
		
		//Do before
		app.lockPageScroll(false);
		
		
		
		//Animate the overlay & iframe
		$('#js-overlay').fadeOut(app.settings.overlaySpeed);
		$('#js-overlay iframe').animate({
			opacity: 0
		}, app.settings.overlaySpeed); 
		
		//do after..
		
		setTimeout(function(){
			
			//Stop the video
			ytPlayer.video.stop();
			
			//If trailer track as watched
			if (ytPlayer.watching === app.settings.trailerID) {
				ytPlayer.trailerWatched = true;
			}
			
			//If homepage and page isnt loaded
			if (page.current === 'home' && !page.pageLoaded) {
				
				//Check if ui needs to be loaded...
				if (!page.uiloaded) {
					page.ui('home');
				} 
				
				//If UI is already laoded then jsut show the page
				else {
					page.show('home');
				}
				
			}
			ytPlayer.isOpen = false;
			audio.play();

		}, app.settings.overlaySpeed);
		
	},
	
};